<p-panelMenu [model]="items" class="align-items-center justify-content-center fadeinleft animation-duration-2000">
</p-panelMenu>

